<template>
    <!-- 储值充值报表管理－页面 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'storedRechargeReport')">
            <div slot="header">
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                    <a-form-item label="会员手机号">
                        <a-input placeholder="请输入" v-decorator="['account']"></a-input>
                    </a-form-item>
                    <a-form-item label="充值时间">
                        <a-range-picker style="width:282px" showTime format="YYYY/MM/DD HH:mm" v-decorator="['dateTime',{initialValue: [$moment($moment().format('YYYY/MM/DD 00:00:00')),$moment($moment().format('YYYY/MM/DD 23:59:59'))]}]" />
                    </a-form-item>
                    <a-form-item label="支付方式">
                        <a-select allowClear placeholder="请选择" v-decorator="['payMode']" >
                            <template v-for="(item,index) in $utils.payMode">
                                <a-select-option :key="index" :value="index" v-if="index > 0">{{item}}</a-select-option>
                            </template>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="订单编号">
                        <a-input placeholder="请输入" v-decorator="['id']"></a-input>
                    </a-form-item>
                    <a-form-item label="充值方式">
                        <a-select allowClear placeholder="请选择" v-decorator="['orderPlatform']">
                            <a-select-option value="1" >线下门店</a-select-option>
                            <a-select-option value="2" >官方app</a-select-option>
                            <a-select-option value="3" >微信小程序</a-select-option>
                            <a-select-option value="4" >第三方购买</a-select-option>
                            <a-select-option value="5" >管理后台</a-select-option>
                            <a-select-option value="6" >其他</a-select-option>
                            <a-select-option value="7" >点餐小程序</a-select-option>
                            <a-select-option value="8" >吧台</a-select-option>
                            <a-select-option value="9" >阿派朗点餐小程序</a-select-option>
                            <a-select-option value="10" >第三方购买</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="getAll" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div>
            <a-card :bordered="false">
                <a-alert slot="title" type="warning" showIcon>
                    <template slot="message">
                        <span class="text-primary mr8">实际支付总额：{{pointDetail.payAmountSumMoney || 0.00}}元</span>
                        <a-divider type="vertical" />
                        <span class="text-primary ml8">{{pointDetail.payCount || 0}}笔</span>
                    </template>
                </a-alert>
                <a-button v-if="getBtnByAuth('storedRechargeExport')" @click="exportStatistics" :loading="tableLoading" slot="extra" class="ml80">导出</a-button>
                <a-table style="word-break:break-all;" bordered :dataSource="dataSource" :loading="tableLoading" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                    <span slot="payMode" slot-scope="payMode">{{$utils.payMode[payMode] || "-"}}</span>
                    <span slot="orderPlatform" slot-scope="orderPlatform">{{['','线下门店','官方app','微信小程序','第三方购买','管理后台','其他','点餐小程序','吧台','阿派朗点餐小程序'][orderPlatform] || "-"}}</span>
                    <span slot="state" slot-scope="state">{{$utils.payState[state] || "-"}}</span>
                    <div slot="expandedRowRender" slot-scope="row" v-if="getBtnByAuth('storedRechargeDetail')">
                        <a-table size="small" :bordered="false" :dataSource="row.userOrderDetailVoList" :columns="columnsDetail" :pagination="false" :rowKey="(record,index) => index"></a-table>
                    </div>
                </a-table>
            </a-card>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script>
const columns = [
    {
        title: '订单号',
        dataIndex: 'id'
    },
    {
        title: '会员手机号',
        dataIndex: 'account'
    },
    {
        title: '充值时间',
        dataIndex: 'payTime'
    },
    {
        title: '实际支付金额/元',
        dataIndex: 'payMoney'
    },
    {
        title: '支付方式',
        dataIndex: 'payMode',
        scopedSlots: { customRender: 'payMode'}

    },
    {
        title: '充值方式',
        dataIndex: 'orderPlatform',
        scopedSlots: { customRender: 'orderPlatform'}
    },
    {
        title: '状态',
        dataIndex: 'state',
        scopedSlots: { customRender: 'state'}
    }
];
const columnsDetail = [
    {
        title: '商品名称',
        dataIndex: 'goodsName'
    },
    {
        title: '商品单价/元',
        dataIndex: 'price'
    },
    {
        title: '购买数量',
        dataIndex: 'count'
    },
    {
        title: '合计/元',
        dataIndex: 'priceSum'
    }
];
export default {
    name: "storedRechargeReport",
    components: {},
    props: {},
    data() {
        return {
            columns,
            columnsDetail,
            dataSource:[],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            pointDetail: {},
            tableLoading: false
        };
    },
    computed: {},
    beforeCreate() {
        this.filterForm = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getAll()
    },
    methods: {
        getAll() {
            this.pagination.current = 1;
            this.getList()
            this.getPointSum()
        },
        getPointSum() {
            this.filterForm.validateFields((err,values) => {
                if(!err) {
                    const dateTime = values['dateTime'] ? values['dateTime'] : [];
                    values.rechargeStartTime = dateTime.length > 0 ? dateTime[0].format('YYYY-MM-DD HH:mm:00') : '';
                    values.rechargeEndTime = dateTime.length > 0 ? dateTime[1].format('YYYY-MM-DD HH:mm:00') : '';
                    delete values.dateTime;
                    this.$api.statement.storedValueRechargeSum({body: values}).then(res => {
                        this.pointDetail = res;
                    })
                }
            })
        },
        /**
         * @changePage 切换table分页
         */
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList()
        },
        handleReset() {
            this.filterForm.resetFields();
            this.getAll()
        },
        getList() {
            this.filterForm.validateFields((err,values) => {
                if(!err) {
                    const dateTime = values['dateTime'] ? values['dateTime'] : [];
                    values.rechargeStartTime = dateTime.length > 0 ? dateTime[0].format('YYYY-MM-DD HH:mm:00') : '';
                    values.rechargeEndTime = dateTime.length > 0 ? dateTime[1].format('YYYY-MM-DD HH:mm:00') : '';
                    delete values.dateTime
                    
                    values.pageNum = this.pagination.current
                    values.pageSize = this.pagination.pageSize

                    this.$api.statement.storedValueRechargeSearch({body: values}).then(res => {
                        this.dataSource = res.data;
                        this.pagination.total = res.total;
                    })
                }
            })
        },
        exportStatistics() {
            this.filterForm.validateFields((err,values) => {
                if(!err) {
                    const dateTime = values['dateTime'] ? values['dateTime'] : [];
                    values.rechargeStartTime = dateTime.length > 0 ? dateTime[0].format('YYYY-MM-DD HH:mm:00') : '';
                    values.rechargeEndTime = dateTime.length > 0 ? dateTime[1].format('YYYY-MM-DD HH:mm:00') : '';
                    delete values.dateTime
                    
                    values.pageNum = 1
                    values.pageSize = 999999

                    this.tableLoading = true;
                    this.$api.statement.exportConsumeRecharge(
                        {
                            body: values
                        },
                        {
                            responseType: "blob"
                        })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });

                        let downloadUrl = window.URL.createObjectURL(blob);

                        let name = this.$route.meta.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'

                        a.setAttribute("href", downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.tableLoading = false
                    }).catch(err => {
                        this.tableLoading = false

                    })
                }
            })
        },
    }
}
</script>
<style lang="scss">
</style>